export default __webpack_public_path__ + "static/media/threeFamily.ce8b661e.jpg";